export default "__VITE_ASSET__820595f5__"